import { useState } from 'react'

import { Download, File } from 'lucide-react'

import { LANGUAGE_OPTIONS } from '@/services/user/constant'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

import { getFilename } from '@/lib/utils/utils'

interface LanguageProps {
  language:
    | {
        language: string | undefined
        language_level: string | undefined
        url: string | undefined
      }[]
    | undefined
}

export function Language(props: LanguageProps) {
  const { language } = props
  const [show, setShow] = useState<boolean>(true)
  const idAccordion = 'language'

  return (
    <>
      <Accordion
        defaultValue={idAccordion}
        type="single"
        collapsible
        className="w-full rounded-md border-t-4 border-t-[#D91F2E] bg-white"
        onValueChange={(value) => setShow(value === idAccordion)}
      >
        <AccordionItem value={idAccordion} className="border-none p-0">
          <AccordionTrigger className="border-b border-b-[#EAECF0] p-6">
            <div className="flex w-full items-center justify-between">
              <div>Bahasa</div>
              <div className="text-xs">{show ? 'Sembunyikan' : ''}</div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="w-full">
            {language?.length == 0 ? (
              <div className="flex justify-center p-4">Tidak ada data</div>
            ) : (
              <></>
            )}
            <div className="flex w-full flex-col gap-4 divide-y">
              {language?.map((t, key) => {
                const languageOptions = LANGUAGE_OPTIONS.find(
                  (x) => x.value === t.language?.toUpperCase()
                )

                return (
                  <div className="grid w-full grid-cols-4 gap-4 p-6">
                    <div className="flex flex-col">
                      <div className="font-semibold">Bahasa</div>
                      <div>{languageOptions?.label}</div>
                    </div>
                    <div className="col-span-3 flex flex-col">
                      <div className="font-semibold">Dokumen Pendukung</div>
                      <div className="flex">
                        <a href={t.url} target="_blank">
                          <div className="flex min-w-52 items-center justify-between gap-4 rounded-md border border-[#98A2B3] px-3 py-2">
                            <div className="flex items-center gap-2">
                              <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-[#D91F2E] bg-[#FFF4F5]">
                                <File className="h-4 w-4 text-[#D91F2E]" />
                              </div>
                              <div>
                                <div className="text-sm font-semibold">
                                  {getFilename(t.url ?? '')}
                                </div>
                                {/* <div className='text-xs'>200 KB</div> */}
                              </div>
                            </div>
                            <div>
                              <Download className="h-5 w-5 cursor-pointer text-[#D91F2E]" />
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="font-semibold">Level Bahasa</div>
                      <div>
                        {
                          languageOptions?.level?.find(
                            (x) => x.value === t.language_level?.toUpperCase()
                          )?.label
                        }
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  )
}
